<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Personal development'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingHome"
							>
								<mat-card>
									<mat-card-header>
										<mat-card-title
											><span
												[innerHtml]="'Timeline' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span
										></mat-card-title>
									</mat-card-header>

									<mat-card-content>
										<ng-container *ngIf="screen.timelineChart">
											<div
												*ngIf="(screen.timelineChart) as $config"
												style="height: 15em; width: 98%"
											>
												<canvas
													baseChart
													class="chart"
													[data]="$config.data"
													[type]="$config.type"
													[options]="$config.options"
													[plugins]="$config.plugins"
												>
												</canvas>
											</div>
										</ng-container>
									</mat-card-content>
								</mat-card>
								<div
									class="layout-block fill"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<mat-card [style.flex]="'1 1 auto'">
										<mat-card-header>
											<div mat-card-avatar>
												<mat-icon
													[innerHtml]="'badge'"
													fontSet="material-icons"
													[inline]="false"
												></mat-icon>
											</div>
											<mat-card-title
												><span
													[innerHtml]="'My personal development' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></mat-card-title>
										</mat-card-header>

										<mat-card-content>
											<ng-container *ngIf="screen.myGss?.length; else else5"
												><div
													class="layout-block vertical"
													[style.align-items]="'inherit'"
													[style.gap]="'0.25em'"
												>
													<ng-container
														*ngFor="let gs of screen.myGss; let gsIndex = index; trackBy: trackByAutomatic"
													>
														<ng-container
															*lowgileScope="gs; as: 'gs'; let $scope"
														>
															<ng-container
																*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
															>
																<mat-card>
																	<mat-card-header>
																		<mat-card-title
																			><span
																				[innerHtml]="`Development cycle ${gs.cycle.getDateRange()}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																			></span
																		></mat-card-title>
																	</mat-card-header>

																	<mat-card-content>
																		<div
																			class="layout-block vertical"
																			[style.align-items]="'inherit'"
																			[style.gap]="'1em'"
																		>
																			<ng-container
																				*ngIf="gs.status.employeeShouldAct; else else6"
																				><div
																					class="layout-block"
																					[style.align-items]="'inherit'"
																					[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																					[style.gap]="'1em'"
																				>
																					<mat-icon
																						[innerHtml]="'badge'"
																						fontSet="material-icons"
																						[inline]="false"
																					></mat-icon>
																					<div
																						class="layout-block vertical"
																						[style.align-items]="'inherit'"
																						[style.gap]="'0.5em'"
																					>
																						<span
																							style="
																								font-weight: bold;
																							"
																							[innerHtml]="`You should ${gs.status.nextAction} until ${gs.nextActionDeadlineStr}.` | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span>
																						<span
																							[innerHtml]="`(Your personal development process is currently in status \&quot;${gs.status.label}\&quot;)` | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span>
																						<a
																							routerLink="/GoalSettingView"
																							[queryParams]="{ id: gs.id }"
																							routerLinkActive="is-current-link"
																							target="_self"
																						>
																							<span
																								style="
																									font-weight: bold;
																								"
																								[innerHtml]="'Click here to go to your personal development process' | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span>
																						</a>
																					</div></div
																			></ng-container>
																			<ng-template #else6>
																				<ng-container
																					*ngIf="gs.status.managerShouldAct; else else39"
																					><div
																						class="layout-block"
																						[style.align-items]="'inherit'"
																						[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																						[style.gap]="'1em'"
																					>
																						<mat-icon
																							[innerHtml]="'account_tree'"
																							fontSet="material-icons"
																							[inline]="false"
																						></mat-icon>
																						<div
																							class="layout-block vertical"
																							[style.align-items]="'inherit'"
																							[style.gap]="'0.5em'"
																						>
																							<span
																								[innerHtml]="`Your manager should ${gs.status.nextAction} until ${gs.nextActionDeadlineStr}.` | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span>
																							<span
																								[innerHtml]="`(Your personal development process is currently in status \&quot;${gs.status.label}\&quot;)` | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span>
																							<a
																								routerLink="/GoalSettingView"
																								[queryParams]="{ id: gs.id }"
																								routerLinkActive="is-current-link"
																								target="_self"
																							>
																								<span
																									[innerHtml]="'Click here to go to your personal development process' | escapeHtml: 'none' | replaceNewlines: 'span'"
																								></span>
																							</a>
																						</div></div
																				></ng-container>
																				<ng-template
																					#else39
																				>
																					<div
																						class="layout-block"
																						[style.align-items]="'inherit'"
																						[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																						[style.gap]="'1em'"
																					>
																						<mat-icon
																							[innerHtml]="'check'"
																							fontSet="material-icons"
																							[inline]="false"
																						></mat-icon>
																						<div
																							class="layout-block vertical"
																							[style.align-items]="'inherit'"
																							[style.gap]="'0.5em'"
																						>
																							<span
																								[innerHtml]="'There is currently nothing to do.' | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span>
																							<span
																								[innerHtml]="`(Your personal development process is currently in status \&quot;${gs.status.label}\&quot;)` | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span>
																							<a
																								routerLink="/GoalSettingView"
																								[queryParams]="{ id: gs.id }"
																								routerLinkActive="is-current-link"
																								target="_self"
																							>
																								<span
																									[innerHtml]="'Click here to go to your personal development process' | escapeHtml: 'none' | replaceNewlines: 'span'"
																								></span>
																							</a>
																						</div>
																					</div>
																				</ng-template>
																			</ng-template>
																		</div>
																	</mat-card-content>
																</mat-card>
															</ng-container>
														</ng-container>
													</ng-container></div
											></ng-container>
											<ng-template #else5>
												<span
													style="font-style: italic"
													[innerHtml]="'You currently don\'t have open personal development processes. Please reach out to HR if this is wrong.' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</ng-template>
										</mat-card-content>
									</mat-card>
									<mat-card [style.flex]="'1 1 auto'">
										<mat-card-header>
											<div mat-card-avatar>
												<mat-icon
													[innerHtml]="'group'"
													fontSet="material-icons"
													[inline]="false"
												></mat-icon>
											</div>
											<mat-card-title
												><span
													[innerHtml]="'My team\'s personal development' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></mat-card-title>
										</mat-card-header>

										<mat-card-content>
											<ng-container
												*ngIf="screen.teamGss?.length; else else15"
												><lowgile-table
													#datatable_35
													[dataSignal]="_DataTableBlock_collectionCodeSignal_35(datatable_35, { app, screen, $pathSegments, $disabled })"
													[trackBy]="trackByAutomatic"
													[columns]="_DataTableBlock_columns_35(screen)"
													[showSettings]="false"
													[userDefinedConfiguration]="undefined"
													[usePaging]="true"
													[pageSize]="20"
													[pageSizeOptions]="[10, 20, 50]"
													[useGlobalFilter]="false"
													[debouncingDelay]="250"
													[stickyHeader]="true"
													[additionalFindOptions]="_DataTableBlock_additionalFindOptions_35({ app, screen, $pathSegments, $disabled })"
													[additionalHeaderRows]="[]"
													[additionalFooterRows]="[]"
													[allClasses]="$Modules"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[surroundingScope]="$scope"
													#$table_35="lowgileTable"
												>
													<ng-container [lowgile-column]="'column_34'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Development cycle' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let gs; let gsIndex = index"
															[attr.data-label]="'Development cycle'"
														>
															<ng-container
																*lowgileScope="gs; as: 'gs'; let $scope"
															>
																<ng-container
																	*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
																>
																	<span
																		[innerHtml]="_DataTableColumnBlock_cellText_34({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_34') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container [lowgile-column]="'column_29'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Team member' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let gs; let gsIndex = index"
															[attr.data-label]="'Team member'"
														>
															<ng-container
																*lowgileScope="gs; as: 'gs'; let $scope"
															>
																<ng-container
																	*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
																>
																	<a
																		routerLink="/GoalSettingView"
																		[queryParams]="{ id: gs.id }"
																		routerLinkActive="is-current-link"
																		target="_self"
																	>
																		<span
																			[innerHtml]="gs.employee?.name | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</a>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_29') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container [lowgile-column]="'column_28'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Status' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let gs; let gsIndex = index"
															[attr.data-label]="'Status'"
														>
															<ng-container
																*lowgileScope="gs; as: 'gs'; let $scope"
															>
																<ng-container
																	*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
																>
																	<span
																		[innerHtml]="_DataTableColumnBlock_cellText_28({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_28') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container [lowgile-column]="'column_27'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Next action' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let gs; let gsIndex = index"
															[attr.data-label]="'Next action'"
														>
															<ng-container
																*lowgileScope="gs; as: 'gs'; let $scope"
															>
																<ng-container
																	*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
																>
																	<ng-container
																		*ngIf="gs.status.nextAction"
																		><span
																			[style.font-weight]="gs.status.managerShouldAct ? 'bold' : ''"
																			[innerHtml]="gs.nextAction | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span
																	></ng-container>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_27') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container [lowgile-column]="'column_60'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Next action deadline' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let gs; let gsIndex = index"
															[attr.data-label]="'Next action deadline'"
														>
															<ng-container
																*lowgileScope="gs; as: 'gs'; let $scope"
															>
																<ng-container
																	*lowgileScope="gsIndex; as: 'gsIndex'; let $scope"
																>
																	<span
																		[innerHtml]="_DataTableColumnBlock_cellText_60({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_60') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container> </lowgile-table
											></ng-container>
											<ng-template #else15>
												<span
													style="font-style: italic"
													[innerHtml]="'You don\'t have any team members with open personal development processes. Please reach out to HR if this is wrong.' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</ng-template>
										</mat-card-content>
									</mat-card>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
